import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { FormattedMessage } from "react-intl";
import DraggableModal from "../../../common/DraggableModal";
import DraggableModalHead from "../../../common/DraggableModal/DraggableModalHead";
import DraggableModalBody from "../../../common/DraggableModal/DraggableModalBody";
import VersionHistoryContainer from "./VersionHistoryContainer";
import SimpleModalCompact from "../../../common/ModalCompact/SimpleModalCompact";

const useStyles = makeStyles(theme => ({
  modal: {
    width: "1200px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
}));

const VersionHistoryModal = ({
  locked,
  allowDownload,
  open,
  handleClose,
  resourceId,
  folderId,
  onUploadResource
}) => {

  return (
    <SimpleModalCompact fullScreen={false} open={open} onClose={handleClose} title={<FormattedMessage id="version.historyFileFor" />}>
        <VersionHistoryContainer
        locked={locked}
        allowDownload={allowDownload}
          resourceId={resourceId}
          folderId={folderId}
          onUploadResource={onUploadResource }
      />
    </SimpleModalCompact>
  );
};

VersionHistoryModal.defaultProps = {
  locked: false,
};

VersionHistoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resourceId: PropTypes.string.isRequired,
  locked: PropTypes.bool,
};

export default VersionHistoryModal;
